<template lang='pug'>
.popup
  .popup-overlay(@click="closePopup")
  .popup-body
    .popup-body--textOnly
      .popup-onlyText
        p.popup-paragraph
          | {{ text[0] }}
          br
          | {{ text[1] }}
    PopupButtonsOnBottom(:isActive="true" :isScrollablePopup='false' :isSingleButton='true' @send="closePopup")
</template>

<script>
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue'
import { lockBody, unlockBody } from '@/plugins/tool.js'

export default {
  props: {
    text: Array
  },
  components: {
    PopupButtonsOnBottom
  },
  mounted() {
    lockBody()
  },
  methods: {
    closePopup() {
      unlockBody()
      this.$emit("closePopup")
    }
  }
}
</script>
